"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Branch = exports.Tree = exports.CRUD = void 0;
// A 'CRUD' (Create-Read-Update-Delete) is a set of roles linked together that form operations on a common object type.
// for us, D (Delete) is always covered by the Edit permission.
class CRUD {
    constructor({ c, r, u } = {}) {
        this.c = c ?? null;
        this.r = r ?? null;
        this.u = u ?? null;
    }
}
exports.CRUD = CRUD;
// a permission tree is a broad category of permissions
// aligned with a page or function
class Tree {
    constructor(name, branches) {
        this.name = name;
        this.branches = branches;
    }
}
exports.Tree = Tree;
// a branch is under a tree, and may hold a CRUD role set,
// as well as have children of its own
class Branch {
    constructor(name, crud = new CRUD(), branches = []) {
        this.name = name;
        this.crud = crud;
        this.branches = branches;
    }
}
exports.Branch = Branch;
